import { render, staticRenderFns } from "./TheConfirmationDialog.vue?vue&type=template&id=7883eb42"
import script from "./TheConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./TheConfirmationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports